import {
    Box, Button, Card, CardActionArea, CardContent, CircularProgress, Grid, Paper, Stack, Typography,
} from "@mui/material";
import { useContext } from "react";
import { UserContext } from "../Context/UserContext";
import * as MuiIcons from '@mui/icons-material';
import AppsIcon from '@mui/icons-material/Apps';
import { useTranslation } from "../hooks/useTranslation";

function AppIcon({ app }) {
    if (app.image) {
        return (
            <Box
                component="img"
                src={app.image}
                alt={app.name}
                sx={{ width: 72, height: 72, objectFit: 'contain', borderRadius: 2 }}
            />
        );
    }

    const IconComponent = app.icon ? MuiIcons[app.icon] : null;
    if (IconComponent) {
        return <IconComponent sx={{ color: '#FF7233', fontSize: '72px' }} />;
    }
    return <AppsIcon sx={{ color: '#FF7233', fontSize: '72px' }} />;
}

export default function Programs() {
    const { userInfo } = useContext(UserContext);
    const t = useTranslation('Programs.json');
    const loading = userInfo == null;
    const enableApps = (userInfo?.applications || []).filter((app) => app.url);

    const openApp = (app) => {
        window.location.href = app.url;
    };

    return (
        <Box sx={{ width: '100%', p: 3 }}>
            <Stack sx={{ mb: 3 }}>
                <Typography variant="h4" sx={{ fontWeight: 600 }}>{t('programs.title')}</Typography>
                <Typography color="text.secondary">{t('programs.subtitle')}</Typography>
            </Stack>

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
                    <CircularProgress sx={{ color: '#FF7233' }} />
                </Box>
            ) : enableApps.length > 0 ? (
                <Grid container spacing={3}>
                    {enableApps.map((app) => (
                        <Grid key={app.client_id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                            <Card
                                elevation={1}
                                sx={{
                                    borderRadius: 3,
                                    height: '100%',
                                    transition: 'box-shadow .2s, transform .2s',
                                    '&:hover': { boxShadow: 6, transform: 'translateY(-2px)' }
                                }}
                            >
                                <CardActionArea
                                    onClick={() => openApp(app)}
                                    sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch', p: 2 }}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2, pb: 1 }}>
                                        <AppIcon app={app} />
                                    </Box>
                                    <CardContent sx={{ textAlign: 'center' }}>
                                        <Typography gutterBottom variant="h6" component="div">
                                            {app.name}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {app.short_description}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Paper elevation={1} sx={{ borderRadius: 3, p: 6, textAlign: 'center' }}>
                    <Typography variant="h5" gutterBottom>{t('programs.empty.title')}</Typography>
                    <Typography color="text.secondary" sx={{ mb: 3 }}>{t('programs.empty.subtitle')}</Typography>
                    <Button
                        variant="contained"
                        sx={{ bgcolor: 'primary.main', '&:hover': { bgcolor: 'primary.dark' } }}
                    >
                        {t('programs.empty.cta')}
                    </Button>
                </Paper>
            )}
        </Box>
    );
}
